import { IAsrConfig } from '../../@types/asr'

type FilesSource = File[] | FileList | Blob[] | null | undefined

const toFileArray = (files?: FilesSource): File[] => {
  if (!files) return []

  if (Array.isArray(files)) {
    return files.filter(Boolean) as File[]
  }

  return Array.from(files).filter(Boolean) as File[]
}

export const prepareAsrUploadPayload = (formData: IAsrConfig, files?: FilesSource) => {
  const audioFiles = toFileArray(files)

  const payload: Record<string, any> = {
    convert_digits: formData.convert_digits,
    use_punctuation: formData.use_punctuation,
    include_breaks: formData.include_breaks,
    translate: formData.translate,
    restore_case: formData.restore_case,
    profanity_filter: formData.profanity_filter,
    classify: formData.classify,
    decoder_name: formData.decoder_name,
    language: formData.language,
    use_stream: formData.use_stream,
    split_channels: formData.split_channels,
    timestamps: (formData as any).timestamps ?? 0,
    audio_blob: audioFiles,
  }

  if (formData.sample_rate) {
    payload.sample_rate = formData.sample_rate
  }

  if (formData.vad_type) {
    payload.vad_type = formData.vad_type
  }

  if (audioFiles.length && !formData.use_stream) {
    delete payload.sample_rate
    delete payload.vad_type
  }

  return payload
}
